import { render, staticRenderFns } from "./BSLoading.vue?vue&type=template&id=58682f94&"
import script from "./BSLoading.vue?vue&type=script&lang=js&"
export * from "./BSLoading.vue?vue&type=script&lang=js&"
import style0 from "./BSLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports